module.exports = __webpack_public_path__ + "70786c2401019be599a782e2ab255aba.png";